export default __webpack_public_path__ + "images/8T.85d4fe3.png";